var _a, _b;
import { deleteUndefined, mapIfDefined } from './utils';
import * as v1 from '@wix/wix-data-schema-types';
import * as v2 from '@wix/ambassador-data-v2-data-collection/types';
import { roleToV1, fieldTypeToV1, pluginsToV1, fieldPluginsToV1 } from './mappings';
var pagingModes = (_a = {},
    _a[v2.PagingMode.OFFSET] = v1.PagingMode.Offset,
    _a[v2.PagingMode.CURSOR] = v1.PagingMode.Cursor,
    _a);
var collectionTypeToStorageV1 = (_b = {},
    _b[v2.CollectionType.NATIVE] = v1.Storage.docstore,
    _b[v2.CollectionType.WIX_APP] = v1.Storage.driver,
    _b[v2.CollectionType.BLOCKS_APP] = v1.Storage.staticAppSchema,
    _b[v2.CollectionType.EXTERNAL] = v1.Storage.external,
    _b);
var dataOperationsToV1 = {
    'IS_REFERENCED': v1.DataOperation.isReferenced,
    'INSERT': v1.DataOperation.insert,
    'SAVE': v1.DataOperation.save,
    'BULK_INSERT': v1.DataOperation.bulkInsert,
    'BULK_UPDATE': v1.DataOperation.bulkUpdate,
    'UPDATE': v1.DataOperation.update,
    'TRUNCATE': v1.DataOperation.truncate,
    'REMOVE': v1.DataOperation.remove,
    'REMOVE_REFERENCE': v1.DataOperation.removeReference,
    'COUNT': v1.DataOperation.count,
    'FIND': v1.DataOperation.find,
    'REPLACE_REFERENCES': v1.DataOperation.replaceReferences,
    'BULK_REMOVE': v1.DataOperation.bulkRemove,
    'INSERT_REFERENCE': v1.DataOperation.insertReference,
    'GET': v1.DataOperation.get,
    'BULK_SAVE': v1.DataOperation.bulkSave,
    'QUERY_REFERENCED': v1.DataOperation.queryReferenced,
    'DISTINCT': v1.DataOperation.distinct,
    'AGGREGATE': v1.DataOperation.aggregate,
    'PATCH': v1.DataOperation.patch,
    'BULK_PATCH': v1.DataOperation.bulkPatch
};
var _collectionOperationsToV1 = {
    'UPDATE': v1.CollectionOperation.UPDATE,
    'REMOVE': v1.CollectionOperation.REMOVE
};
var _queryOperationsToV1 = {
    'EQ': v1.AllowedFilterOperator.eq,
    'LT': v1.AllowedFilterOperator.lt,
    'GT': v1.AllowedFilterOperator.gt,
    'NE': v1.AllowedFilterOperator.ne,
    'LTE': v1.AllowedFilterOperator.lte,
    'GTE': v1.AllowedFilterOperator.gte,
    'STARTS_WITH': v1.AllowedFilterOperator.startsWith,
    'ENDS_WITH': v1.AllowedFilterOperator.endsWith,
    'CONTAINS': v1.AllowedFilterOperator.contains,
    'HAS_SOME': v1.AllowedFilterOperator.hasSome,
    'HAS_ALL': v1.AllowedFilterOperator.hasAll,
    'EXISTS': v1.AllowedFilterOperator.exists,
    'URLIZED': v1.AllowedFilterOperator.urlized
};
export function convertV2SchemaToV1(collection) {
    var _a, _b, _c;
    var _ = collection;
    return deleteUndefined({
        id: _.id,
        isDeleted: false,
        namespace: namespaceFromCollectionId(_.id),
        storage: collectionTypeToStorageV1[_.collectionType],
        ownerAppId: _.ownerAppId || null,
        displayNamespace: _.displayNamespace || null,
        displayField: _.displayField,
        allowedOperations: toAllowedOperationsV1(_),
        collectionOperations: toCollectionOperationsV1(_),
        fields: toFieldsV1(_),
        displayName: (_a = _.displayName) !== null && _a !== void 0 ? _a : _.id,
        permissions: toPermissionsV1(_),
        dataPermissions: toPermissionsV2(_),
        allowedPermissions: toAllowedPermissions(_),
        maxPageSize: (_b = _.maxPageSize) !== null && _b !== void 0 ? _b : undefined,
        defaultSort: toSortV1(_.defaultDisplayOrder),
        version: toVersionV1(_.revision),
        plugins: toPluginsV1(_.plugins),
        pagingMode: (_c = _.pagingModes) === null || _c === void 0 ? void 0 : _c.map(function (m) { return pagingModes[m]; }),
        translatable: false,
        ttl: null,
        capabilities: toCapabilitiesV1(_)
    });
}
function toVersionV1(revision) {
    var version = parseInt(revision !== null && revision !== void 0 ? revision : '0', 10);
    if (isNaN(version))
        return 0;
    return version;
}
function toPermissionsV1(collection) {
    if (!collection.permissions)
        return undefined;
    var _ = collection.permissions;
    return {
        'read': roleToV1[_.read],
        'insert': roleToV1[_.insert],
        'remove': roleToV1[_.remove],
        'update': roleToV1[_.update]
    };
}
function toPermissionsV2(collection) {
    if (!collection.dataPermissions)
        return undefined;
    var toAccessLevel = function (level) {
        switch (level) {
            case v2.AccessLevel.ANYONE:
                return v1.AccessLevel.ANYONE;
            case v2.AccessLevel.SITE_MEMBER:
                return v1.AccessLevel.SITE_MEMBER;
            case v2.AccessLevel.SITE_MEMBER_AUTHOR:
                return v1.AccessLevel.SITE_MEMBER_AUTHOR;
            case v2.AccessLevel.CMS_EDITOR:
                return v1.AccessLevel.CMS_EDITOR;
            default:
                return v1.AccessLevel.PRIVILEGED;
        }
    };
    var _ = collection.dataPermissions;
    return {
        itemRead: toAccessLevel(_.itemRead),
        itemInsert: toAccessLevel(_.itemInsert),
        itemUpdate: toAccessLevel(_.itemUpdate),
        itemRemove: toAccessLevel(_.itemRemove)
    };
}
function toAllowedPermissions(collection) {
    var _a, _b, _c, _d;
    if (!collection.allowedDataPermissions)
        return undefined;
    var ps = collection.allowedDataPermissions;
    return {
        itemInsert: (_a = ps.itemInsert) !== null && _a !== void 0 ? _a : false,
        itemRead: (_b = ps.itemRead) !== null && _b !== void 0 ? _b : false,
        itemUpdate: (_c = ps.itemUpdate) !== null && _c !== void 0 ? _c : false,
        itemRemove: (_d = ps.itemRemove) !== null && _d !== void 0 ? _d : false
    };
}
function toAllowedOperationsV1(collection) {
    var _a;
    var operations = (_a = collection === null || collection === void 0 ? void 0 : collection.capabilities) === null || _a === void 0 ? void 0 : _a.dataOperations;
    return operations === null || operations === void 0 ? void 0 : operations.map(function (o) { return dataOperationsToV1[o]; });
}
function toCollectionOperationsV1(collection) {
    var _a;
    var operations = (_a = collection === null || collection === void 0 ? void 0 : collection.capabilities) === null || _a === void 0 ? void 0 : _a.collectionOperations;
    return operations === null || operations === void 0 ? void 0 : operations.map(function (o) { return _collectionOperationsToV1[o]; });
}
function toSortV1(sort) {
    if (!sort)
        return null;
    return {
        direction: sort.direction === v2.Direction.DESC ? v1.Direction.desc : v1.Direction.asc,
        fieldName: sort.fieldKey
    };
}
function toPluginsV1(plugins) {
    if (!plugins)
        return undefined;
    return pluginsToV1(plugins);
}
function toFieldsV1(collection) {
    if (!collection.fields)
        return {};
    return collection.fields.reduce(function (fieldsByKey, field, index) {
        var _a;
        return Object.assign({}, fieldsByKey, (_a = {}, _a[field.key] = _toFieldV1(field, index), _a));
    }, {});
}
function _toFieldV1(field, index) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4;
    var _ = field;
    return deleteUndefined({
        displayName: (_a = _.displayName) !== null && _a !== void 0 ? _a : _.key,
        systemField: (_b = _.systemField) !== null && _b !== void 0 ? _b : false,
        sortable: (_c = _ === null || _ === void 0 ? void 0 : _.capabilities) === null || _c === void 0 ? void 0 : _c.sortable,
        isDeleted: false,
        index: index,
        queryOperators: toQueryOperatorsV1(_),
        plugin: (_d = _ === null || _ === void 0 ? void 0 : _.plugin) !== null && _d !== void 0 ? _d : undefined,
        calculator: toCalculatorV1(_),
        pii: _.encrypted ? true : undefined,
        linkedRouterPage: (_g = (_f = (_e = _ === null || _ === void 0 ? void 0 : _.typeMetadata) === null || _e === void 0 ? void 0 : _e.pageLink) === null || _f === void 0 ? void 0 : _f.linkedRouterPage) !== null && _g !== void 0 ? _g : undefined,
        description: (_h = _.description) !== null && _h !== void 0 ? _h : undefined,
        readOnly: (_j = _.readOnly) !== null && _j !== void 0 ? _j : undefined,
        immutable: (_k = _.immutable) !== null && _k !== void 0 ? _k : undefined,
        required: (_l = _.required) !== null && _l !== void 0 ? _l : undefined,
        minValue: (_o = (_m = _ === null || _ === void 0 ? void 0 : _.numberRange) === null || _m === void 0 ? void 0 : _m.min) !== null && _o !== void 0 ? _o : undefined,
        maxValue: (_q = (_p = _ === null || _ === void 0 ? void 0 : _.numberRange) === null || _p === void 0 ? void 0 : _p.max) !== null && _q !== void 0 ? _q : undefined,
        minStrLength: (_s = (_r = _ === null || _ === void 0 ? void 0 : _.stringLengthRange) === null || _r === void 0 ? void 0 : _r.minLength) !== null && _s !== void 0 ? _s : undefined,
        maxStrLength: (_u = (_t = _ === null || _ === void 0 ? void 0 : _.stringLengthRange) === null || _t === void 0 ? void 0 : _t.maxLength) !== null && _u !== void 0 ? _u : undefined,
        minArraySize: (_w = (_v = _ === null || _ === void 0 ? void 0 : _.arraySizeRange) === null || _v === void 0 ? void 0 : _v.minSize) !== null && _w !== void 0 ? _w : undefined,
        maxArraySize: (_y = (_x = _ === null || _ === void 0 ? void 0 : _.arraySizeRange) === null || _x === void 0 ? void 0 : _x.maxSize) !== null && _y !== void 0 ? _y : undefined,
        type: fieldTypeToV1[_.type],
        referencedCollection: toReferencedCollectionV1(_.typeMetadata),
        referencingFieldKey: (_0 = (_z = _.typeMetadata) === null || _z === void 0 ? void 0 : _z.multiReference) === null || _0 === void 0 ? void 0 : _0.referencingFieldKey,
        referencingDisplayName: (_2 = (_1 = _.typeMetadata) === null || _1 === void 0 ? void 0 : _1.multiReference) === null || _2 === void 0 ? void 0 : _2.referencingDisplayName,
        fields: toObjectTypeV1(_.typeMetadata),
        elementType: toArrayElementTypeV1(_.typeMetadata),
        pattern: (_4 = (_3 = _.typeMetadata) === null || _3 === void 0 ? void 0 : _3.slug) === null || _4 === void 0 ? void 0 : _4.pattern,
        plugins: mapIfDefined(_.plugins, fieldPluginsToV1)
    });
}
function toTypePropsV1(type, typeMetadata) {
    return {
        type: fieldTypeToV1[type],
        fields: toObjectTypeV1(typeMetadata),
        elementType: toArrayElementTypeV1(typeMetadata)
    };
}
function toObjectTypeV1(typeMetadata) {
    var _a;
    var object = typeMetadata === null || typeMetadata === void 0 ? void 0 : typeMetadata.object;
    if (!object)
        return undefined;
    return (_a = object.fields) === null || _a === void 0 ? void 0 : _a.reduce(function (fieldsByKey, field) {
        var _a;
        return Object.assign(fieldsByKey, (_a = {}, _a[field.key] = toNestedFieldV1(field), _a));
    }, {});
}
function toNestedFieldV1(field) {
    var _a;
    return deleteUndefined(Object.assign({
        displayName: field.displayName,
        sortable: (_a = field === null || field === void 0 ? void 0 : field.capabilities) === null || _a === void 0 ? void 0 : _a.sortable,
        queryOperators: toQueryOperatorsV1(field)
    }, toTypePropsV1(field.type, field.typeMetadata)));
}
function toArrayElementTypeV1(typeMetadata) {
    var array = typeMetadata === null || typeMetadata === void 0 ? void 0 : typeMetadata.array;
    if (!array)
        return undefined;
    return deleteUndefined(toTypePropsV1(array.elementType, array.typeMetadata));
}
function toQueryOperatorsV1(field) {
    var _a;
    var operators = (_a = field === null || field === void 0 ? void 0 : field.capabilities) === null || _a === void 0 ? void 0 : _a.queryOperators;
    if (!operators)
        return [];
    // all operators are the same as none
    if (operators.length >= Object.keys(_queryOperationsToV1).length)
        return undefined;
    return operators.map(function (o) { return _queryOperationsToV1[o]; });
}
function toCalculatorV1(field) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    var pageLink = (_a = field.typeMetadata) === null || _a === void 0 ? void 0 : _a.pageLink;
    return pageLink ?
        {
            config: {
                lowercase: (_d = (_c = (_b = pageLink.calculator) === null || _b === void 0 ? void 0 : _b.fieldsPattern) === null || _c === void 0 ? void 0 : _c.lowercase) !== null && _d !== void 0 ? _d : false,
                pattern: (_k = (_g = (_f = (_e = pageLink.calculator) === null || _e === void 0 ? void 0 : _e.fieldsPattern) === null || _f === void 0 ? void 0 : _f.pattern) !== null && _g !== void 0 ? _g : (_j = (_h = pageLink.calculator) === null || _h === void 0 ? void 0 : _h.urlizedOnlyPattern) === null || _j === void 0 ? void 0 : _j.pattern) !== null && _k !== void 0 ? _k : 'unknown'
            }
        } :
        undefined;
}
function namespaceFromCollectionId(collectionId) {
    if (!collectionId)
        return null;
    var index = collectionId.lastIndexOf('/');
    if (index === -1)
        return null;
    return collectionId.substring(0, index);
}
function toReferencedCollectionV1(typeMetadata) {
    var _a, _b, _c;
    return ((_b = (_a = typeMetadata === null || typeMetadata === void 0 ? void 0 : typeMetadata.multiReference) === null || _a === void 0 ? void 0 : _a.referencedCollectionId) !== null && _b !== void 0 ? _b : (_c = typeMetadata === null || typeMetadata === void 0 ? void 0 : typeMetadata.reference) === null || _c === void 0 ? void 0 : _c.referencedCollectionId);
}
function toCapabilitiesV1(collection) {
    var _a, _b;
    var indexQuotaLimits = (_a = collection === null || collection === void 0 ? void 0 : collection.capabilities) === null || _a === void 0 ? void 0 : _a.indexQuotaLimits;
    if (indexQuotaLimits) {
        return {
            indexing: {
                regular: indexQuotaLimits.regular1Field + indexQuotaLimits.regular3Field,
                regular1Field: indexQuotaLimits.regular1Field,
                compound: indexQuotaLimits.regular3Field,
                unique: indexQuotaLimits.unique1Field,
                total: indexQuotaLimits.total
            }
        };
    }
    var indexLimits = (_b = collection === null || collection === void 0 ? void 0 : collection.capabilities) === null || _b === void 0 ? void 0 : _b.indexLimits;
    if (!indexLimits)
        return undefined;
    return {
        indexing: {
            regular: indexLimits.regular,
            unique: indexLimits.unique,
            total: indexLimits.total
        }
    };
}
//# sourceMappingURL=v2-to-v1-converter.js.map